var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "customer-service-work-bench" }, [
    _c("div", { staticClass: "work-bench-left" }, [
      _c("div", { staticClass: "work-bench-left-top" }, [
        _c("div", { staticClass: "filter-area" }, [
          _c(
            "div",
            { staticClass: "selectDateL" },
            [
              _c("Icon", {
                staticClass: "caption-icon",
                attrs: { type: "md-calendar" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "caption" }, [_vm._v("待办订单")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "weekMonth" },
                _vm._l(_vm.selectedData, function (item, index) {
                  return _c(
                    "span",
                    {
                      key: index,
                      staticClass: "orange",
                      class: item.selectedFlag ? "selected" : "",
                      on: {
                        click: function ($event) {
                          return _vm.selected(index)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.title))]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "selectTime" },
                [
                  _c("DatePicker", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      transfer: true,
                      type: "daterange",
                      options: _vm.selectDate,
                      placement: "bottom-end",
                    },
                    on: { "on-change": _vm.selectTimeChange },
                    model: {
                      value: _vm.dateArr,
                      callback: function ($$v) {
                        _vm.dateArr = $$v
                      },
                      expression: "dateArr",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "selectDateR" },
            [
              _c(
                "Select",
                {
                  attrs: {
                    multiple: "",
                    multipleType: "",
                    filterable: "",
                    chooseAll: "",
                  },
                  on: {
                    "on-change": _vm.onchange,
                    "on-open-change": _vm.timeOpenChange,
                  },
                  model: {
                    value: _vm.warehouse,
                    callback: function ($$v) {
                      _vm.warehouse = $$v
                    },
                    expression: "warehouse",
                  },
                },
                _vm._l(_vm.option, function (item, index) {
                  return _c(
                    "Option",
                    { key: index, attrs: { value: item.id } },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "manage-list" }, [
          _c("div", { staticClass: "Loading1" }, [
            _c(
              "ul",
              { staticClass: "manage-left" },
              _vm._l(_vm.statisticalList, function (item, index) {
                return _c("li", { key: index }, [
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.jumpOrderClick(item.key, item.value)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.value))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "manage-name",
                      attrs: { title: item.prompt },
                    },
                    [_vm._v(_vm._s(item.name))]
                  ),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.Loading1,
                    expression: "Loading1",
                  },
                ],
                staticClass: "fromLoading",
              },
              [_c("Spin")],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "Loading2" }, [
            _c(
              "ul",
              { staticClass: "manage-right" },
              _vm._l(_vm.statisticalList2, function (item, index) {
                return _c("li", { key: index }, [
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.jumpReturnClick(item.key, item.value)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.value))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "manage-name",
                      attrs: { title: item.prompt },
                    },
                    [_vm._v(_vm._s(item.name))]
                  ),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.Loading2,
                    expression: "Loading2",
                  },
                ],
                staticClass: "fromLoading",
              },
              [_c("Spin")],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "work-bench-echart" }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
            },
          },
          [
            _c(
              "div",
              [
                _c("Icon", {
                  staticClass: "overview-icon",
                  attrs: { type: "logo-buffer" },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "overview-title" }, [
                  _vm._v("经营概览"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "refreshDate" },
              [
                _c("Icon", {
                  staticStyle: { "vertical-align": "baseline" },
                  attrs: { type: "md-alarm" },
                }),
                _vm._v(" "),
                _c("span", [_vm._v("更新时间：" + _vm._s(_vm.newTime))]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "margin-left": "10px",
                      color: "#3C8DBC",
                      cursor: "pointer",
                    },
                    on: { click: _vm.getList },
                  },
                  [_vm._v("刷新")]
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticStyle: { width: "100%", height: "400px", left: "-45px" },
          attrs: { id: "main" },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.Loading3,
                expression: "Loading3",
              },
            ],
            staticClass: "fromLoading",
          },
          [_c("Spin")],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "work-bench-right" }, [
      _c("div", { staticClass: "Loading4" }, [
        _c("div", { staticClass: "bench-total totalSales" }, [
          _c("div", { staticClass: "totalSales-top" }, [
            _c("span", { staticClass: "total-title" }, [_vm._v("销售总额")]),
            _vm._v(" "),
            _c("span", { staticClass: "total-btn" }, [
              _vm._v(_vm._s(_vm.dateTime)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "total-amt sales-pg" }, [
            _c("p", [
              _vm._v("￥"),
              _c("span", { staticClass: "amt-color" }, [
                _vm._v(_vm._s(_vm.scaleAmt.SALE_TOT_AMT)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "total-percentage sales-pg" },
            [
              _c("span", [_vm._v(_vm._s(_vm.scaleAmt.SALE_SCALE))]),
              _vm._v(" "),
              _vm.orderIcon == "up"
                ? _c("Icon", {
                    staticClass: "total-icon",
                    attrs: { type: "ios-arrow-round-up" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.orderIcon == "down"
                ? _c("Icon", {
                    staticClass: "total-icon",
                    attrs: { type: "ios-arrow-round-down" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bench-total totalRefund" }, [
          _c("div", { staticClass: "totalSales-top" }, [
            _c("span", { staticClass: "total-title" }, [_vm._v("退款总额")]),
            _vm._v(" "),
            _c("span", { staticClass: "total-btn btn-bule" }, [
              _vm._v(_vm._s(_vm.dateTime)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "total-amt refund-pg" }, [
            _c("p", [
              _vm._v("￥"),
              _c("span", { staticClass: "amt-color" }, [
                _vm._v(_vm._s(_vm.scaleAmt.SALE_RETURN_TOT_AMT)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "total-percentage refund-pg" },
            [
              _c("span", [_vm._v(_vm._s(_vm.scaleAmt.RETURN_SCALE))]),
              _vm._v(" "),
              _vm.returnIcon == "up"
                ? _c("Icon", {
                    staticClass: "total-icon",
                    attrs: { type: "ios-arrow-round-up" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.returnIcon == "down"
                ? _c("Icon", {
                    staticClass: "total-icon",
                    attrs: { type: "ios-arrow-round-down" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.Loading4,
                expression: "Loading4",
              },
            ],
            staticClass: "fromLoading",
          },
          [_c("Spin")],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "work-bench-right-bottom" },
        [_c("info-list", { attrs: { info: _vm.publicInfo } })],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowFromLoading,
            expression: "isShowFromLoading",
          },
        ],
        staticClass: "fromLoading",
      },
      [_c("Spin")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }